import InputLabel from "@mui/material/InputLabel";

export default InputLabel;
